export function isNetworkError(error) {
    if (!(error instanceof Error)) {
        return false;
    }
    const message = error.message.toLowerCase();
    const name = error.name;
    return (name === 'AxiosError' ||
        name === 'NetworkError' ||
        message.includes('network error') ||
        message.includes('failed to fetch') ||
        message.includes('load failed') ||
        message.includes('networkerror') ||
        message.includes('err_network') ||
        message.includes('err_internet_disconnected') ||
        message.includes('err_connection') ||
        message.includes('could not load') ||
        (name === 'TypeError' && message.includes('fetch')));
}
